import { MstatusData, GetMstatusData } from "../../../services/MachineStatusService"
import { useEffect, useState } from "react"
import { loadAttributes } from "../../../Slices/AttributesSlice"
import { useAppDispatch } from '../../../app/hooks'
import { MachineStatusDial } from "./MachineStatusDial"
import { CheckboxWarning20Regular, Dismiss20Regular } from '@fluentui/react-icons';
import { removeCard } from "../../../Slices/DashboardSlice";
import { CardHeader } from "../Machine/CardHeader";
import { CollapseTop } from "../Machine/CollapseTop"
import { CollapsableSection } from "../Machine/CollapsableSection"
import { CardProps } from "../CardProps"

export function MachineStatusCard(cardProps: CardProps) {
    const [mStatusData, setMStatusData] = useState({} as MstatusData);
    const dispatch = useAppDispatch();

    const [expanded, setExpanded] = useState(true);

    const Dismiss = () => {
        dispatch(removeCard({ eguid: cardProps.elementGuid, type: cardProps.type }))
    }

    const icon = <CheckboxWarning20Regular />;

    useEffect(() => {
        (async () => {
            const data = await GetMstatusData(cardProps.elementGuid);
            if (data) {

                const sortedMStatusDatas = data?.MStatusDatas?.sort((a, b) =>
                    a.Alias.localeCompare(b.Alias)) || [];

                setMStatusData(prevState => ({
                    ...prevState,
                    MStatusDatas: sortedMStatusDatas
                }))
                data.MStatusDatas.forEach((mStatus) => {
                    dispatch(loadAttributes
                        ({
                            elementGuid: mStatus.ElementGuid,
                            attributeGuid: mStatus.AttributeGuid,
                            hoursStarting: 0
                        })
                    );
                });
            }
        })();

    }, [cardProps.elementGuid, dispatch]);


    const Elements = () => {
        return <div className="px-4">
            <div className="grid grid-cols-[repeat(auto-fill,minmax(4rem,1fr))]
            gap-5 pt-5 pb-6">
                {mStatusData?.MStatusDatas?.length > 0 && mStatusData?.MStatusDatas?.map((mStatus) => {
                    return (
                        <MachineStatusDial
                            key={mStatus.AttributeGuid}
                            ElementName={mStatus.ElementName}
                            Alias={mStatus.Alias}
                            attributeGuid={mStatus.AttributeGuid}
                        />
                    )
                })}
            </div>
        </div>
    }

    return (
        <div
            className=" bg-primary-light bg-primary border-border-light
        dark:bg-primary-dark dark:border-border-dark border-1 drop-shadow-lg "
            data-tour={`card-mstatus-${cardProps.elementGuid}`}
        >

            <CardHeader title={"Machine status"} subtitle={cardProps.name} onClick={Dismiss} icon={icon} />
            <div className="py-2 space-y-2 pt-5">
                <CollapseTop title="Machine status" expand={() => setExpanded(!expanded)} rightValueUnderline={true} startsExpanded={true} />
                <CollapsableSection expanded={expanded} children={<Elements />} />


            </div>


        </div>

    )
}
